mutation ConnectCCBill($input: ConnectCCBillInput!) {
  connectCCBill(input: $input) {
    id
    paymentSettings {
      provider
      ccbill {
        accnum
        subaccount
        flexFormId
        saltMask
        webhookUrl
        supportUrl
        sandbox
        connectedAt
      }
    }
  }
}
